module.exports = __webpack_public_path__ + "static/crater-lake-zoom-32f4cd7b498e529ce8f6eccd6e3f59cc.jpg";